import { de, enUS, fr } from 'date-fns/locale';

import { getUserDetails, isJsonString } from '.';

export const nationalCityIds = [2, 4, 5, 6, 7, 8, 9];

export const all_cities = [
  {
    id: 1,
    value: 1,
    name: 'Zurich (EN)',
    label: 'Zurich (EN)',
    slug: 'zurich-en',
    lang_id: 1,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 47.3744489,
      lng: 8.5410422,
    },
    fb_link: null,
    insta_link: null,
  },
  {
    id: 2,
    value: 2,
    name: 'Zürich',
    label: 'Zürich',
    slug: 'zurich',
    lang_id: 3,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 47.3744489,
      lng: 8.5410422,
    },
    fb_link: 'https://www.facebook.com/ronorpzuerich',
    insta_link: 'https://www.instagram.com/ronorpch/',
  },
  {
    id: 3,
    value: 3,
    name: 'Romandie',
    label: 'Romandie',
    slug: 'romandie',
    lang_id: 2,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 46.8,
      lng: 6.6333,
    },
    fb_link: null,
    insta_link: null,
  },
  {
    id: 4,
    value: 4,
    name: 'Basel',
    label: 'Basel',
    slug: 'basel',
    lang_id: 3,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 47.5596,
      lng: 7.5886,
    },
    fb_link: 'https://www.facebook.com/ronorpbasel',
    insta_link: 'https://www.instagram.com/ron_orp_basel/',
  },
  {
    id: 5,
    value: 5,
    name: 'Bern',
    label: 'Bern',
    slug: 'bern',
    lang_id: 3,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 46.948,
      lng: 7.4474,
    },
    fb_link: 'https://www.facebook.com/ronorpbern',
    insta_link: 'https://www.instagram.com/ron_orp_bern/',
  },
  {
    id: 6,
    value: 6,
    name: 'Luzern',
    label: 'Luzern',
    slug: 'luzern',
    lang_id: 3,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 47.0502,
      lng: 8.3093,
    },
    fb_link: 'https://www.facebook.com/ronorpluzern',
    insta_link: 'https://www.instagram.com/ronorpluzern/',
  },
  {
    id: 7,
    value: 7,
    name: 'St. Gallen',
    label: 'St. Gallen',
    slug: 'st-gallen',
    lang_id: 3,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 47.425618,
      lng: 9.3762397,
    },
    fb_link: 'https://www.facebook.com/ronorpst.gallen',
    insta_link: 'https://www.instagram.com/ronorp_stgallen/',
  },
  {
    id: 8,
    value: 8,
    name: 'Winterthur',
    label: 'Winterthur',
    slug: 'winterthur',
    lang_id: 3,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 47.4991723,
      lng: 8.7291498,
    },
    fb_link: 'https://www.facebook.com/ronorpwinterthur',
    insta_link: 'https://www.instagram.com/ronorpwthur/',
  },
  {
    id: 9,
    value: 9,
    name: 'Family Zurich',
    label: 'Family Zurich',
    slug: 'family-zurich',
    lang_id: 3,
    created_at: '2023-10-30T08:23:25.000000Z',
    updated_at: '2023-10-30T08:23:25.000000Z',
    location: {
      lat: 47.3744489,
      lng: 8.5410422,
    },
    fb_link: 'https://www.facebook.com/ronorpfamily',
    insta_link: 'https://www.instagram.com/ronorpfamily/',
  },
];

export const convertCityNameToSlug = (cityName) => {
  if (!cityName) return 'zurich';
  if (cityName === 'Zürich' || cityName === 'zürich') return 'zurich';
  if (cityName === 'Zürich (EN)' || cityName === 'zürich-en') return 'zurich-en';
  return cityName
    ?.toLowerCase()
    ?.replaceAll(' ', '-')
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll('.', '');
};

export const convertCitySlugToName = (citySlug) => {
  if (!citySlug) return 'Zürich';
  return citySlug
    ?.replaceAll('-', ' ')
    .replaceAll('zurich', 'Zürich')
    .replaceAll('zurich-en', 'Zurich (EN)')
    .replaceAll('st-gallen', 'St. Gallen')

};

export function getCityDetailsFromId(cityId) {
  return all_cities.find((item) => item?.id == cityId);
}

export function isGermanCity(cityId) {
  return nationalCityIds.includes(cityId);
}

export function getCityDetailsFromName(cityName = '') {
  return all_cities.find(
    (item) => item?.slug == convertCityNameToSlug(cityName)
  );
}

export function getLangBasedOnCity(city) {
  const cityDetails = getCityDetailsFromName(city);
  if (cityDetails?.lang_id == 1) return 'en';
  else if (cityDetails?.lang_id == 2) return 'fr';
  else return 'de';
}

export const getUserCity = () => {
  const userData = getUserDetails();

  if (userData) {
    return {
      id: userData?.city_id,
      name: userData?.city_name,
      slug: convertCityNameToSlug(userData?.city_name),
    };
  }

  return null;
};

export function getCityDetails(cityName) {
  for (let i = 0; i < all_cities.length; i++) {
    if (all_cities[i].slug === convertCityNameToSlug(cityName)) {
      return all_cities[i];
    }
  }
  return all_cities[1];
}

export const getSelectedCity = () => {
  if (typeof window !== 'undefined') {
    const isJSON = isJsonString(localStorage.getItem('selectedCity'));
    const city = isJSON
      ? JSON.parse(localStorage.getItem('selectedCity'))
      : null;
    if (city) {
      return {
        id: city.id,
        name: city.name,
        slug: city.slug,
      };
    } else {
      return {
        id: 2,
        name: 'Zürich',
        slug: 'zurich',
      };
    }
  }
};

export function getCityFromUrl() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('city');
}

export const getCityId = () => {
  if (typeof window !== 'undefined') {
    const city = JSON.parse(localStorage.getItem('selectedCity'));
    return city ? city.id : '';
  }
};

export function getLocale(cityId) {
  if (cityId == 1) return enUS;
  else if (cityId == 3) return fr;
  else return de;
}

export function getLocaleString(cityId) {
  if (cityId == 1) return 'en';
  else if (cityId == 3) return 'fr';
  else return 'de';
}
